export const FONT = {
  "Font.Weight.Regular": {
    defaultValue: "400"
  },
  "Font.Weight.Medium": {
    defaultValue: "500"
  },
  "Font.Weight.SemiBold": {
    defaultValue: "600"
  },
  "Font.Size.36": {
    defaultValue: "36px"
  },
  "Font.Size.32": {
    defaultValue: "32px"
  },
  "Font.Size.28": {
    defaultValue: "28px"
  },
  "Font.Size.24": {
    defaultValue: "24px"
  },
  "Font.Size.20": {
    defaultValue: "20px"
  },
  "Font.Size.18": {
    defaultValue: "18px"
  },
  "Font.Size.16": {
    defaultValue: "16px"
  },
  "Font.Size.15": {
    defaultValue: "15px"
  },
  "Font.Size.14": {
    defaultValue: "14px"
  },
  "Font.Size.13": {
    defaultValue: "13px"
  },
  "Font.Size.12": {
    defaultValue: "12px"
  },
  "Font.Size.11": {
    defaultValue: "11px"
  },
  "Font.Size.10": {
    defaultValue: "10px"
  },
  "Line.Height.Mega": {
    defaultValue: "1.28"
  },
  "Line.Height.H1": {
    defaultValue: "1.31"
  },
  "Line.Height.H2": {
    defaultValue: "1.29"
  },
  "Line.Height.H3": {
    defaultValue: "1.33"
  },
  "Line.Height.H4": {
    defaultValue: "1.5"
  },
  "Line.Height.H5": {
    defaultValue: "1.56"
  },
  "Line.Height.H6": {
    defaultValue: "1.63"
  },
  "Line.Height.Baseplus": {
    defaultValue: "1.47"
  },
  "Line.Height.Base": {
    defaultValue: "1.57"
  },
  "Line.Height.Smallplus": {
    defaultValue: "1.54"
  },
  "Line.Height.Small": {
    defaultValue: "1.67"
  },
  "Line.Height.Tiny": {
    defaultValue: "1.64"
  },
  "Line.Height.Micro": {
    defaultValue: "1.2"
  },
  "Letter.Spacing.Mega": {
    defaultValue: "-1.2px"
  },
  "Letter.Spacing.H1": {
    defaultValue: "-1px"
  },
  "Letter.Spacing.H2": {
    defaultValue: "-0.96px"
  },
  "Letter.Spacing.H3": {
    defaultValue: "-0.56px"
  },
  "Letter.Spacing.H4": {
    defaultValue: "-0.5px"
  },
  "Letter.Spacing.H5": {
    defaultValue: "-0.3px"
  },
  "Letter.Spacing.H6": {
    defaultValue: "-0.2px"
  },
  "Letter.Spacing.Baseplus": {
    defaultValue: "0.01px"
  },
  "Letter.Spacing.Base": {
    defaultValue: "0px"
  },
  "Letter.Spacing.Smallplus": {
    defaultValue: "0px"
  },
  "Letter.Spacing.Small": {
    defaultValue: "normal"
  },
  "Letter.Spacing.Tiny": {
    defaultValue: "normal"
  },
  "Letter.Spacing.Micro": {
    defaultValue: "normal"
  }
};
